import { html } from 'lit';
import { FsPaginationArrows } from '@cof/fs-pagination-wc';
import { style } from './fs-pagination.style.js';

export class RefiArrowPagination extends FsPaginationArrows {
  connectedCallback() {
    super.connectedCallback();
    this.addEventListener('click', this.emitPageChangeEvent);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.removeEventListener('click', this.emitPageChangeEvent);
  }

  static get styles() {
    return [style, ...FsPaginationArrows.styles];
  }

  determineButtonSvg(buttonId) {
    return buttonId === super.currentPage ? 'assets/filled-dot-button.svg' : 'assets/empty-dot-button.svg';
  }

  renderButtons() {
    const buttonTemplates = [];
    for (let x = 1; x <= super.pageCount; x += 1) {
      buttonTemplates.push(html`
        <button id="${x}" name="${`page${x}`}" aria-current="${x === super.currentPage}" @click="${this.handlePaginationButtonClick}">
          <img src="${this.determineButtonSvg(x)}" alt="${`slide ${x}`}" />
        </button>
      `);
    }
    return buttonTemplates;
  }

  handlePaginationButtonClick(event) {
    super.currentPage = parseInt(event.currentTarget.id, 10);
  }

  render() {
    return html`
      <nav aria-label="${this.accessibilityLabel}" class="${super.constructedClass}" role="navigation">
        <ul class="fs-pagination__list">
          <!-- Render "previous" button. -->
          ${this._renderDirectionControl('previous-page', this.currentPage === 1)} ${this.renderButtons()}
          <!-- Render "next" button. -->
          ${this._renderDirectionControl('next-page', this.currentPage === this.pageCount)}
        </ul>
      </nav>
    `;
  }

  emitPageChangeEvent() {
    this.dispatchEvent(
      new CustomEvent('selectedUpdated', {
        detail: {
          newValue: super.currentPage,
        },
        bubbles: true,
        composed: true,
      }),
    );
  }
}

customElements.define('refi-arrow-pagination', RefiArrowPagination);
